import { render, staticRenderFns } from "./CadastroUsuarioLicitacao.vue?vue&type=template&id=0be8ceae&scoped=true&"
import script from "./CadastroUsuarioLicitacao.vue?vue&type=script&lang=js&"
export * from "./CadastroUsuarioLicitacao.vue?vue&type=script&lang=js&"
import style0 from "./CadastroUsuarioLicitacao.vue?vue&type=style&index=0&id=0be8ceae&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be8ceae",
  null
  
)

export default component.exports